module.exports = __webpack_public_path__ + "static/media/trash-detail.65a634af.svg";